/// <amd-module name="Artifacts/Root/components/ErrorBannerLoader" />

import { CenteredSpinner } from "Artifacts/Root/components/CenteredSpinner";
import { ComponentStateSwitch } from "Artifacts/Root/components/ComponentStateSwitch";
import { ComponentState } from "Artifacts/Root/Constants";
import * as Res from "Artifacts/Root/Resources";
import * as React from "react";
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";

interface IErrorBannerLoaderProps {
  state: ComponentState;
  noLoadingSpinner?: boolean;
  errorClassName?: string;
}

/**
 * ErrorBannerLoader provides default loading spinner and error components and render then depending on the ComponentStatus.
 * TODO: styles
 */
const ErrorBannerLoader: React.FC<IErrorBannerLoaderProps> = ({
  state,
  noLoadingSpinner = false,
  children,
  errorClassName,
}) => (
  <ComponentStateSwitch
    state={state}
    loading={noLoadingSpinner ? children : <CenteredSpinner />}
    ready={children}
    error={
      <div className="flex-column">
        <MessageBar className={errorClassName} severity={MessageBarSeverity.Error}>
          {state.errorMessage || Res.GenericError}
        </MessageBar>
        {children}
      </div>
    }
  />
);

export { ErrorBannerLoader };
